import { getDomainConfigValue } from "./utils/domain-config";

export const Endpoints = {
  generic: () => `/data/generic/generic.json`,
  newArrivals: () => "/api/data/menus/new-arrivals",
  menus: (category, submenu, asset) => {
    if (category === "new-arrivals" && !submenu && !asset) {
      return Endpoints.newArrivals();
    }
    if (getDomainConfigValue("dataRepository") === "cms") {
      if (asset) {
        return `/api/data/assets/${category}/${submenu}/${asset}`;
      }
      return `/api/data/menus/${category}${submenu ? `/${submenu}` : ""}`;
    }
    if (asset) {
      return `/data/models/${category}/${asset}.json`;
    }
    return `/data/menus/${category}/${submenu || category}.json`;
  },
  termsPage: () => `/data/generic/terms-and-conditions.json`,
  faqPage: () => `/data/generic/faq.json`,
  privacyPolicyPage: () => `/data/generic/privacy-policy.json`,
  creditCardPrivacyPolicyPage: () =>
    `/data/generic/credit-card-privacy-policy.json`,
  refundPolicyPage: () => `/data/generic/refund-policy.json`,
  creditCardTermsPage: () =>
    `/data/generic/credit-card-terms-and-conditions.json`,
  helpCenterPage:()=> `/data/generic/help-center.json`,
  chatMetaData: () => `/data/generic/chat-metadata.json`,

  ...(getDomainConfigValue("dataRepository") === "cms"
    ? {
        models: (category, submenu, model) =>
          `/api/data/assets/${category}/${submenu}/${model}`,
        videos: (category) => `/data/videos/${category}.json`,
      }
    : {
        models: (category, submenu, model) =>
          `/data/models/${category}/${model}.json`,
        videos: (category) => `/data/videos/${category}.json`,
      }),
};
